export default "__VITE_ASSET__BXq4Xx8P__"